const swiperCheckSlides = document.querySelectorAll('.swiper-check .swiper-slide');

const swiperCheck = new Swiper('.swiper-check', {
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    watchOverflow: true,
    
    breakpoints: {
        640: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 32,
            loop: swiperCheckSlides.length > 4
        }
    },

    pagination: {
        el: '.swiper-check .hoox-swiper-dots',
        clickable: true,
    },

    navigation: {
        nextEl: '.swiper-check .hoox-swiper-next',
        prevEl: '.swiper-check .hoox-swiper-prev',
    },
});